import core from '../../../js/core/core'
import * as types from '../mutation-types'

// initial state
const state = {
  otrSportList: [],

}

// getters
const getters = {

    otrSportList: state => state.otrSportList
}

// actions
const actions = {
    // getOutrightLeague(context, payload){
    //   var data = {
    //       sprtid: this.getters.selectedBettype.sprtId,
    //       lang: window._langid,
    //       action: '1',
    //   }

    //   //TODO 1. if select league id, pass leagueid param
    //   // data.lgeid = this.getters.arr_selectedLeague.leagueid
    //   // data.action = '2'
    //   console.log(11111111111111111)

    //   core.$ajax({
    //     method: 'post',
    //     url: 'sport-outright-league',
    //     data: data
    //   }).done(((res)=> {
    //     this.commit('PARLAYDATELIST', res.earlyParlayDateList)
    //     return res
    //   }).bind(this)).catch((errRes)=> {
    //     console.log(errRes)
    //   })
    // },
    getSportOutrightOdds(context, payload) {
        var url = ''

        if (this.getters.account.previewFlag == true) {
            url = window._baseUrl + '/sport-outright-odds-preview'
        } else {
            url = window._baseUrl + '/sport-outright-odds'
        }

        var data = {
            sprtid: this.getters.selectedBettype.sprtId,
            lang: window._langid,
            token: payload.token,
            odd: this.getters.oddTypesList.EU.key
        }
        if (this.getters.account.oddsType == 'am') {
            data.odd = this.getters.oddTypesList.AM.key
        }
        var STORE = this
            //if show league
        if (this.getters.cookieLeague) {
            // data.leagues = payload.leagueList

            var cookieLeague = this.getters.cookieLeague
            var selectedMarket = this.getters.selectedMarket
            var selectedSport = this.getters.selectedBettype.sprtId
            var selectedBettype = this.getters.selectedBettype.betTypId
            if (!this.getters.selectAllLeague) {
                if (cookieLeague[selectedMarket]) {
                    if (cookieLeague[selectedMarket][selectedSport]) {
                        if (cookieLeague[selectedMarket][selectedSport][selectedBettype] && Object.keys(cookieLeague[selectedMarket][selectedSport][selectedBettype]).length > 0) {
                            url = window._baseUrl + '/sport-outright-league'
                            data.leagues = cookieLeague[selectedMarket][selectedSport][selectedBettype]
                            data.action = '2'
                        } else {
                            if (this.getters.account.previewFlag == true) {
                                url = window._baseUrl + '/sport-outright-odds-preview'
                            } else {
                                url = window._baseUrl + '/sport-outright-odds'
                            }
                        }
                    } else {
                        if (this.getters.account.previewFlag == true) {
                            url = window._baseUrl + '/sport-outright-odds-preview'
                        } else {
                            url = window._baseUrl + '/sport-outright-odds'
                        }
                    }
                } else {
                    if (this.getters.account.previewFlag == true) {
                        url = window._baseUrl + '/sport-outright-odds-preview'
                    } else {
                        url = window._baseUrl + '/sport-outright-odds'
                    }
                }
            } else {
                if (this.getters.account.previewFlag == true) {
                    url = window._baseUrl + '/sport-outright-odds-preview'
                } else {
                    url = window._baseUrl + '/sport-outright-odds'
                }
            }
        }
        core.$ajax({
            method: 'get',
            url: url,
            data: data,
        }).done(((res) => {
            if (payload.leagueList) {
                STORE.commit('SPORT_LEAGUE_TOGGLE')
            }
            var counter = 0;
            var events = _.cloneDeep(res.events)
            if (events && Object.keys(events).length > 0) {
                let currentEveID = []
                let sprtlist = []
                
                // let sport1st = '';
                _.forEach(events, function(value, index) {
                    
                    // if (sport1st != value.sptid) {
                    //     events[1].draw = 1;
                    // }
                    sprtlist.push(value.sptid)
                    currentEveID.push(value.eveid)
                    if (!_.isUndefined(STORE.getters.favouriteOTREvents)) {
                        if (!_.isUndefined(STORE.getters.favouriteOTREvents['N' + value.sptid]) && Object.keys(STORE.getters.favouriteOTREvents['N' + value.sptid]).length > 0) {
                            _.forEach(STORE.getters.favouriteOTREvents['N' + value.sptid], function(favEvent, index2) {
                                if (favEvent == value.eveid) {
                                    counter++
                                }
                            });
                        }
                    }
                });
                var uniqueSites = sprtlist.filter(function(item, i, sprtlist) {
                    return i == sprtlist.indexOf(item);
                });
                this.commit('OTRSPORTLIST', uniqueSites)
                if (STORE.getters.selectedBettype.sprtId != "G98") {
                    _.forEach(STORE.getters.favouriteOTREvents[STORE.getters.selectedBettype.sprtId], function(favEvent, index2) { // remove close event from fav
                        if (!currentEveID.includes(favEvent)) {
                            this.$store.commit('FAVOURITEOTREVENT', { eveId: favEvent, selectedSport: STORE.getters.selectedBettype.sprtId })
                        }
                    });
                }
            }
            this.commit('EVENTLIST', events)
            this.commit('FAVOURITEOTREVENTCOUNT', counter);
            this.commit('EARLYPARLAYDATELIST', res.earlyParlayDateList);
            if (payload.callback) {
                return payload.callback(res)
            }
        }).bind(this)).catch((errRes) => {
            console.log(errRes)
        })
    },
}

// mutations
const mutations = {
    [types.OTRSPORTLIST](state, payload) {
        state.otrSportList = payload
      },
}

export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./resources/wob/vue/store/modules/sport-outright.js